import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { isMoment } from 'moment';

/**
 * ngx-translate enabled wrapper for the angular date pipe.
 */
@Pipe({
  name: 'portalDate',
  pure: false,
  standalone: false,
})
export class PortalDatePipe implements PipeTransform {
  private datePipe!: DatePipe;

  constructor(private translateService: TranslateService) {
    // Create the date pipe with the current language
    this.createDatePipe(translateService.currentLang);

    // Whenever the language changes we need to recreate the date pipe so that angular transforms dates correctly
    translateService.onLangChange.subscribe((event) => {
      this.createDatePipe(event.lang);
    });
  }

  // prettier-ignore
  transform(value: moment.Moment | Date | string | number, format?: PredefinedAngularFormatOptions | PortalFormatOptions | string, timezone?: string, locale?: string): string | null;
  // prettier-ignore
  transform(value: moment.Moment | null | undefined, format?: PredefinedAngularFormatOptions | PortalFormatOptions | string, timezone?: string, locale?: string): null;
  // prettier-ignore
  transform(value: moment.Moment | Date | string | number | null | undefined, format?: PredefinedAngularFormatOptions | PortalFormatOptions | string, timezone?: string, locale?: string): string | null;

  transform(value: moment.Moment | string | number | Date | null | undefined, ...args: any[]): any {
    if (isMoment(value)) {
      value = value.valueOf();
    }

    if (args != null) {
      const format = CustomDateFormats[this.translateService.currentLang]?.[args[0]];

      if (format != null) {
        args[0] = format;
      }
    }

    return this.datePipe.transform(value, ...args);
  }

  private createDatePipe(locale: string) {
    this.datePipe = new DatePipe(locale);
  }
}

type PortalFormatOptions = 'date-time' | 'date-time-no-seconds';

const CustomDateFormats: Record<string, Record<PortalFormatOptions, string>> = {
  de: {
    'date-time': 'dd.MM.yyyy HH:mm:ss',
    'date-time-no-seconds': 'dd.MM.yyyy HH:mm',
  },
  en: {
    'date-time': 'yyyy-MM-dd HH:mm:ss',
    'date-time-no-seconds': 'MMM d, y, h:mm a',
  },
};

/**
 * See https://angular.dev/api/common/DatePipe?tab=usage-notes for more information about the format.
 */
type PredefinedAngularFormatOptions =
  | 'short'
  | 'medium'
  | 'long'
  | 'full'
  | 'shortDate'
  | 'mediumDate'
  | 'longDate'
  | 'fullDate'
  | 'shortTime'
  | 'mediumTime'
  | 'longTime'
  | 'fullTime';
